<template lang="pug">
footer
  .in(v-if="lan == 'kr'")
    .f_top
      ul
        li
          h2 서비스센터
          p 010-2982-0063
        li
          p
            span 평일. 
            | 09:00 ~ 18:00 (점심 12:00 ~ 13:00)
          p
            span 휴무. 
            | 주말 및 공휴일
    .f_bot
      ul
        li
          a(@click='modal("privacy")') 개인정보처리방침
        li
          a(@click='modal("terms")') 이용약관
        li(v-if="!isSigned")
          a(@click='$_goTo({name: "login"})') 관리자
        li(v-if='isSigned')
          a(@click='$_goTo({name: "admin"})') 관리자
        li(v-if="isSigned")
          a(@click='logout()') 로그아웃
      .f_txt
        ul
          li INTHEKEG
          li ADDRESS. 경기도 안양시 동안구 학의로 282 8층 827호 (관양동, 금강펜테리움IT타워)
          li TEL. +82-31-423-3642
          li FAX. +82-31-426-4907
          li EMAIL. info@inthekeg.com
        p.copy Copyright ⓒ 2021 INTHEKEG. ALL RIGHT RESERVED.
      .f_sns
        ul
          li
            a(href='https://www.instagram.com/inthekeg_official' target='_blank')
              img(:src='require("../../assets/images/foo_icon1.png")' alt='main logo')
          li
            a(href='https://www.youtube.com/channel/UC03tOkU9J4pFxL697PMjMiQ' target='_blank')
              img(:src='require("../../assets/images/foo_icon2.png")' alt='main logo')
  .in(v-if="lan == 'en'")
    .f_top
      ul
        li
          h2 CS Center
          p 010-2982-0063
        li
          p
            span Weekdays. 
            | 09:00 ~ 18:00 (lunch break 12:00 ~ 13:00)
          p
            span Closed. 
            | Weekends and holidays
    .f_bot
      ul
        li
          a(@click='modal("privacy")') Privacy Policy
        li
          a(@click='modal("terms")') Terms & Conditions
        li(v-if="!isSigned")
          a(@click='$_goTo({name: "login"})') Admin
        li(v-if='isSigned')
          a(@click='$_goTo({name: "admin"}, "share")') Admin
        li(v-if="isSigned")
          a(@click='logout()') Logout
      .f_txt
        ul
          li INTHEKEG
          li ADDRESS. 827, 8F, 282, Hagui-ro, Dongan-gu, Anyang-si, Gyeonggi-do, Republic of Korea
          li TEL. +82-31-423-3642
          li FAX. +82-31-426-4907
          li EMAIL. info@inthekeg.com
        p.copy Copyright ⓒ 2021 INTHEKEG. ALL RIGHT RESERVED.
      .f_sns
        ul
          li
            a(href='https://www.instagram.com/inthekeg_official' target='_blank')
              img(:src='require("../../assets/images/foo_icon1.png")' alt='main logo')
          li
            a(href='https://www.youtube.com/channel/UC03tOkU9J4pFxL697PMjMiQ' target='_blank')
              img(:src='require("../../assets/images/foo_icon2.png")' alt='main logo')
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['userAccToken', 'userAccTokenExp', 'lan']),
    isSigned() {
      return this.userAccToken === null ? false : true;
    },
  },
  methods: {
    modal(name) {
      window.open(name, name, 'width=600,height=400,scrollbars=yes');
    },
    logout() {
      // NOTE: server에서 jwt blacklist 처리 한다면 사용
      // const $_self = this;
      // this.$_axios('DELETE', 'admin/session', this.userAccToken).then(() => {
      //   $_self.$store.commit('resetStore', {});
      //   $_self.$_goTo({ name: 'home' });
      // });
      this.$store.commit('resetStore', {});
      this.$_goTo({ name: 'home' });
    },
    tokenChecker() {
      if (this.userAccToken == null) {
        return;
      }
      let remainingTime =
        (+new Date(this.userAccTokenExp) - +new Date()) / 1000;
      if (remainingTime < 0) {
        alert('로그인 상태가 만료되었습니다.');
        this.logout();
        return;
      }
    },
  },
  mounted() {
    this.$options.tokenChecker = setInterval(() => this.tokenChecker(), 1000);
  },
  beforeDestroy() {
    clearInterval(this.$options.tokenChecker);
  },
};
</script>

<style scoped>
.f_txt p.copy {
  opacity: 0.5;
  text-align: center;
  padding: 20px 0 25px;
  font-size: 12px;
}
</style>
